const PageTitle = ({ title }) => {
  return (
    <div className="text-2xl font-semibold text-blue-400 sm:text-5xl sm:my-6 font-rajdhani">
      {title}
    </div>
  );
};

export default PageTitle;
